import { createThunk, model, Model } from 'mst-collection';
import { getRoot, types } from 'mobx-state-tree';

import { DurationCourseModel } from './CourseDurationModel';
import { Api } from '@api';
import { IntroVideoCourseModel } from './IntroVideoCourseModel';
import type { RootModelType } from '@models/RootModel';
import { TariffPlanCodeEnum } from '@constants';
import { CourseLessonModelList } from './CourseLessonModelList';
import { CourseUserStatsModel } from './CourseUserStatsModel';

export class Course extends Model({
  id: types.identifierNumber,
  title: types.string,
  description: types.string,
  durationCourse: DurationCourseModel,
  benefits: types.array(types.string),
  studentsCount: types.number,
  introVideo: IntroVideoCourseModel,
  isForTrial: types.boolean,
  lessons: types.optional(CourseLessonModelList, {}),
  userStats: types.maybe(CourseUserStatsModel),
  skillLevel: types.string,
}) {
  get poster() {
    return this.introVideo.covers[0];
  }

  get isAvailableForCurrentPlan(): boolean {
    return !(
      getRoot<RootModelType>(this).viewer.currentUser?.tariffPlan
        .id === TariffPlanCodeEnum.Trial && !this.isForTrial
    );
  }

  get isAllVideosWatched() {
    return (
      this.lessons.totalVideosCount ===
      this.lessons.watchedVideosCount
    );
  }

  start = createThunk(() => {
    return async function markAsStarted(this: Course) {
      await Api.Courses.startCourse({ id: this.id });

      this.userStats?.setIsStarted(true);
    };
  });

  setCurrentTutorial = createThunk((tutorialId: number) => {
    return async function setCurrentTutorial(this: Course) {
      await Api.Courses.setCurrentTutorial({
        courseId: this.id,
        tutorialId,
      });

      this.userStats?.setCurrentVideoId(tutorialId);
    };
  });

  complete = createThunk(() => {
    return async function complete(this: Course) {
      await Api.Courses.completeCourse({ id: this.id });

      this.userStats?.setIsCompleted(true);
    };
  });
}

export const CourseModel = model(Course);
